<template>
  <section class="container">
  <div>
    <div style="margin-top: 80px">
      <h1></h1>
    </div>
    
    <LoginInfoModal v-if="showModal2" @close="showModal2 == false">
      <template slot="header">
        <h3>{{ $t("login.loginInfo") }}</h3>
        <button
          type="button"
          class="btn-close popup_close_bt"
          @click="closeInfoModal"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </template>
      <template slot="body">
        <table class="">
          <tbody>
            <tr>
              <th>{{ $t("login.userName") }}</th>
              <td>{{ user.userName }}</td>
            </tr>
            <tr>
              <th>{{ $t("login.currentIp") }}</th>
              <td>{{ user.recentLoginIp }}</td>
            </tr>
            <tr>
              <th>{{ $t("login.lastIp") }}</th>
              <td>{{ user.lastLoginIp }}</td>
            </tr>
            <tr>
              <th>{{ $t("login.lastLoginTime") }}</th>
              <td>{{ user.lastLoginDatetime }}</td>
            </tr>
          </tbody>
        </table>
      </template>
      <template slot="footer">
        <button
          type="button"
          @click="closeInfoModal"
          @keyup.enter="closeInfoModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.main") }}
        </button>
      </template>
    </LoginInfoModal>      
  </div>
  </section>
</template>

<script>
import { ssoLogin } from "@/api/login";
import { getMenuList } from "@/api/menu";
import LoginInfoModal from "@/components/modal/LoginInfoModal";

export default {
  components: {
      LoginInfoModal
  },
  data() {
    return {
      showModal2: false,
    };
  },
  methods: {
    async ssoLoginProcess() {
      try {
        const response = await ssoLogin();

        if (response.data.status) {
          this.$session.set("token", "Bearer " + response.data.token);
          this.$session.set("loginUser", response.data.loginUser);
          this.$session.set("user", response.data.user);
          this.$session.set("userName", response.data.user.userName);
          this.user = response.data.user;
          this.$store.commit("setFirstLogin", true);
          this.$store.commit("setLoginUser", response.data.loginUser);
          // 메뉴가져오기
          try {
            const { data } = await getMenuList();
            // 메뉴가져왔을시
            if (data.parentMenu != null) {
              this.$session.set("parentMenu", data.parentMenu);
              this.$session.set("subMenu", data.childMenu);
            }
          } catch (error) {
            console.log(error);
          }
          this.$router.push("/main");
        } else {
          alert(this.$t("login.TheresNoLoginInformation"));
          this.$router.push('/login');
        }
      } catch (error) {
        console.log(error);
      }
    },
    nextModal() {
      this.showModal2 = true;
      setTimeout(
        function () {
          this.showModal2 = false;
          this.$router.push("/main");
        }.bind(this),
        2000
      );
    },
    closeInfoModal() {
      this.showModal2 = false;
      this.$router.push("/main");
    },    
  },
  mounted() {
    this.ssoLoginProcess();
  },
};
</script>

<style></style>
